import CachedAsyncImage from "../graphics/CachedAsyncImage";
import {
  CostumeCategory,
  costumeCategoryRegistry,
  CostumeRegistry,
  CostumeSet,
  defaultCostumeSet,
  filterCostumesByCategory,
} from "./Costume";
import {
  CostumeTextureID,
  CostumeTextureInfo,
  CostumeTextureRegistry,
  CostumeTextureSet,
} from "./CostumeTexture";

class CostumeCompositor {
  constructor(
    public readonly costumeRegistry: CostumeRegistry,
    public readonly costumeTextureRegistry: CostumeTextureRegistry
  ) {}

  public compose(costumes: CostumeSet): Array<CachedAsyncImage> {
    // Use default costumes instead of invalid costumes
    const textures = this.validateCostumeSet(costumes)
      ? this.computeTextureSet(costumes)
      : this.computeTextureSet(defaultCostumeSet);

    const textureInfos = this.textureInfosFromTextureSet(textures);
    return textureInfos.map(
      (info) => new CachedAsyncImage(info.path, info.alpha)
    );
  }

  private computeTextureSet(costumes: CostumeSet): CostumeTextureSet {
    const textures = new Set<CostumeTextureID>();

    for (const costume of costumes) {
      const costumeInfo = this.costumeRegistry[costume];

      if (!costumeInfo) {
        continue;
      }

      const _textures =
        costumeInfo.textures instanceof Set
          ? costumeInfo.textures
          : costumeInfo.textures(costumes);
      for (const texture of _textures) {
        textures.add(texture);
      }
    }

    return this.modifyTextureSet(costumes, textures);
  }

  private textureInfosFromTextureSet(
    textures: CostumeTextureSet
  ): Array<CostumeTextureInfo> {
    let textureInfos = new Array<CostumeTextureInfo>();

    for (const texture of textures) {
      const textureInfo = this.costumeTextureRegistry[texture];

      if (!textureInfo) {
        continue;
      }

      textureInfos.push(textureInfo);
    }

    textureInfos = this.modifyTextureInfos(textureInfos);

    return textureInfos.sort((a, b) => a.priority - b.priority);
  }

  // テクスチャの情報をもとに修正を加える
  private modifyTextureSet(
    costumes: CostumeSet,
    textures: CostumeTextureSet
  ): CostumeTextureSet {
    textures.add(CostumeTextureID.Body);
    return textures;
  }

  private modifyTextureInfos(
    textureInfos: Array<CostumeTextureInfo>
  ): Array<CostumeTextureInfo> {
    return textureInfos;
  }

  public validateCostumeSet(costumes: CostumeSet): boolean {
    const requiredCostumeCategories: CostumeCategory[] = [
      "髪型",
      "眉",
      "目",
      "口",
      "腕",
      "服装",
      "帽子",
      "小物",
      "背景",
      "メガネ",
      "耳飾り",
      "目の色",
    ];

    return requiredCostumeCategories.every((category) => {
      // Check required
      if (
        costumeCategoryRegistry[category].required &&
        filterCostumesByCategory(costumes, category).size < 1
      ) {
        return false;
      }

      // Check multiple choice
      if (
        !costumeCategoryRegistry[category].multipleChoice &&
        filterCostumesByCategory(costumes, category).size > 1
      ) {
        return false;
      }

      return true;
    });
  }

  private validateTextureSet(textures: CostumeTextureSet): boolean {
    return true;
  }
}

export default CostumeCompositor;
